import { Injectable } from '@angular/core';
import { ApiServiceService } from '../../../services/api-service.service';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class WorkingHoursService {

    refreshList = new BehaviorSubject<boolean>(false);

    constructor(private apiService: ApiServiceService) { }

    getAll(branchId: any) {
        return this.apiService.get(`${environment.apiUrl}/vendors/working-hours?branch_id=${branchId}`)
            .pipe(catchError(this.handleError));
    }

    storeWorkingHour(branchId: any, data: any) {
        return this.apiService.post(`${environment.apiUrl}/vendors/working-hours/${branchId}`, data)
            .pipe(catchError(this.handleError));
    }

    handleError(error: any) {
        return throwError(error);
    }
}